module.exports = __webpack_public_path__ + "images/schools-adwords-hero.png";


//////////////////
// WEBPACK FOOTER
// ./vively/images/landing/schools-adwords-hero.png
// module id = 866
// module chunks = 3